import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/EAHS44/EAHS44_RevSum_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        CombinedMenuItemType: undefined,
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam Skills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/online-edition.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Knowledge Organisers',
        ImagePath: '/assets/images/landing/knowledge-organisers.png',
        DestinationPage: 'knowledge-organisers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ExamSkillsVideos,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch videos',
    ButtonURL: 'videos',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.NotSet,
      },
    ],
    HasData: false,
    HeadingText: 'Exam Skills Videos',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our experts talk you through how to answer each different-question-type in the exams.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Learn how to write a top answer',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Exam Skills Videos',
        Intro:
          'GCSE English has lots of different question types, and our experts will show you how to write a top answer for each one in these step-by-step videos!',
        LeftSections: [
          {
            Header: 'Paper 1',
            Subcategories: [
              {
                Name: 'Question 1',
                ShortName: 'p1-question-1',
                Link: 'https://www.youtube.com/embed/U3RoH3keuJA?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 2',
                ShortName: 'p1-question-2',
                Link: 'https://www.youtube.com/embed/eUvXlA_abGw?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 3',
                ShortName: 'p1-question-3',
                Link: 'https://www.youtube.com/embed/HFBqB5Kzalo?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 4',
                ShortName: 'p1-question-4',
                Link: 'https://www.youtube.com/embed/PkJD5JpG1To?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 5',
                ShortName: 'p1-question-5',
                Link: 'https://www.youtube.com/embed/TrMY95ehQsA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Paper 2',
            Subcategories: [
              {
                Name: 'Question 1',
                ShortName: 'p2-question-1',
                Link: 'https://www.youtube.com/embed/XG3KSJ3cQdY?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 2',
                ShortName: 'p2-question-2',
                Link: 'https://www.youtube.com/embed/DPaX_lHFb70?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 3',
                ShortName: 'p2-question-3',
                Link: 'https://www.youtube.com/embed/zdEPBFZOakQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 4',
                ShortName: 'p2-question-4',
                Link: 'https://www.youtube.com/embed/3vn4rZUKnxQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 5',
                ShortName: 'p2-question-5',
                Link: 'https://www.youtube.com/embed/tnXhFgsy-aU?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam Skills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/online-edition.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Knowledge Organisers',
        ImagePath: '/assets/images/landing/knowledge-organisers.png',
        DestinationPage: 'knowledge-organisers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Answers,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View answers',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.NotSet,
      },
    ],
    HasData: false,
    HeadingText: 'Answers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See what makes a great answer in the exams! You can also find all your Revision Summary Test answers here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Graded examples for each paper',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: 'Answers',
      ContentMain:
        '<p>Take a look at our example answers for some of the AQA English exam questions &mdash; they&#39;re fully graded to show you the sort of thing examiners are looking for.</p>\n' +
        '\n' +
        '<p>You can also check out the answers to your Revision Summary Tests.</p>\n' +
        '\n' +
        '<p><strong>Fully Graded Answers</strong></p>\n' +
        '\n' +
        '<p><strong><span style="color:#1494D4;"><a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-gcse-english-full-graded-ans-p1q5.pdf" target="_blank">Paper 1 Q5 Graded Answers</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-gcse-english-full-graded-ans-p2q5.pdf" target="_blank">Paper 2 Q5 Graded Answers</a></span></strong></p>\n' +
        '\n' +
        '<p><strong>Revision Summary Answers</strong></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-gcse-english-revision-summary-answers.pdf" target="_blank"><span style="color:#1494D4;"><strong>Revision Summary Answers</strong></span></a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam Skills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/online-edition.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Knowledge Organisers',
        ImagePath: '/assets/images/landing/knowledge-organisers.png',
        DestinationPage: 'knowledge-organisers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.KnowledgeOrganiser,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Knowledge Organisers',
    ButtonURL: 'knowledge-organisers',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.NotSet,
      },
    ],
    HasData: false,
    HeadingText: 'Knowledge Organisers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Handy summaries to help you remember all the important info for your English Literature set texts and poetry.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Key facts for set texts and poetry',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: 'Knowledge Organisers',
      ContentMain:
        '<p>Here are the <strong>Knowledge Organiser</strong> pages from our fantastic new <a aria-label="Link GCSE AQA English Complete Revision &amp; Practice books" href="https://www.cgpbooks.co.uk/secondary-books/gcse/english/language/eahs44-new-gcse-english-language-literature" id="menur6mj" rel="noreferrer noopener" target="_blank" title="https://www.cgpbooks.co.uk/secondary-books/gcse/english/9-1-gcse-english-aqa-complete-revision-practice"><strong>GCSE AQA English Language and Literature Complete Revision &amp; Practice book</strong></a>. They cover every set text and Poetry Anthology that you might have to learn about for your GCSE, condensing all the key info onto a single page. Pick a text to get started!</p>\n' +
        '\n' +
        '<h6><strong>Shakespeare</strong></h6>\n' +
        '\n' +
        '<p><b><a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-julius-caesar-ko.pdf" target="_blank">Julius Caesar</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-macbeth-ko.pdf" target="_blank">Macbeth</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-much-ado-ko.pdf" target="_blank">Much Ado About Nothing</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-romeo-and-juliet-ko.pdf" target="_blank">Romeo and Juliet</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-merchant-of-venice-ko.pdf" target="_blank">The Merchant of Venice</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-tempest-ko.pdf" target="_blank">The Tempest</a></b></font><br />\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h6><b>19th Century</b></h6>\n' +
        '\n' +
        '<p><b><a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-christmas-carol-ko.pdf" target="_blank">A Christmas Carol</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-frankenstein-ko.pdf" target="_blank">Frankenstein</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-great-expectations-ko.pdf" target="_blank">Great Expectations</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-jane-eyre-ko.pdf" target="_blank">Jane Eyre</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-jekyll-ko.pdf" target="_blank">Jekyll and Hyde</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-pride-and-prejudice-ko.pdf" target="_blank">Pride and Prejudice</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-sign-of-four-ko.pdf" target="_blank">The Sign of the Four</a></b></p>\n' +
        '\n' +
        '<h6><b>Post-1914</b></h6>\n' +
        '\n' +
        '<p><b><a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-taste-of-honey-ko.pdf" target="_blank">A Taste of Honey</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-inspector-calls-ko.pdf" target="_blank">An Inspector Calls</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-anita-and-me-ko.pdf" target="_blank">Anita and Me</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-animal-farm_ko.pdf" target="_blank">Animal Farm</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-blood-brothers-ko.pdf" target="_blank">Blood Brothers</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-dna-ko.pdf" target="_blank">DNA</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-leave-taking-ko.pdf" target="_blank">Leave Taking</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-lord-of-the-flies-ko.pdf" target="_blank">Lord of the Flies</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-my-name-is-leon-ko.pdf" target="_blank">My Name is Leon</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-pigeon-english-ko.pdf" target="_blank">Pigeon English</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-princess&the-hustler-ko.pdf" target="_blank">Princess and the Hustler</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-telling-tales-ko.pdf" target="_blank">Telling Tales</a><br />\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h6><b>Poetry</b></h6>\n' +
        '\n' +
        '<p><b><a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-love-and-relationships-ko.pdf" target="_blank">Love and Relationships</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-power-and-conflict-ko.pdf" target="_blank">Power and Conflict</a><br />\n' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/EAHS44/PDFs/cgp-worlds-and-lives-ko.pdf" target="_blank">Worlds and Lives</a></b></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam Skills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/online-edition.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Knowledge Organisers',
        ImagePath: '/assets/images/landing/knowledge-organisers.png',
        DestinationPage: 'knowledge-organisers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.NotSet,
      },
    ],
    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: "<p>We\'ve answered some of the questions you might have.</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        "We've put together lots of helpful information on how to get the most out of your Exam Practice Workbook. And if you've hit any snags, you'll find the answers you need here too. ",
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5><strong>What is CGP RevisionHub?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science Workbooks. Use the quizzes, tests, videos and more to make sure you know your stuff for the exams. &nbsp; &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I access CGP RevisionHub?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though. &nbsp; &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use CGP RevisionHub with my book?</strong> &nbsp;</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig! &nbsp;<strong> &nbsp;</strong><br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>My CGP RevisionHub isn’t working — what do I do?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact"><u>Customer Services team</u></a>.&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge... &nbsp; &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Do I need an internet connection to use CGP RevisionHub?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also useful bits that you can download as PDFs to access offline. Phew. &nbsp; &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>If I log in on a different device, will all my progress be saved?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you. &nbsp; &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What’s the difference between the Quick Quizzes and Your Mistakes Quiz?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the maths skills you’ll need for the course. There's a quiz covering maths skills for Paper 1 and another for Paper 2. &nbsp;</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier. &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use the Online Workbook?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>All the questions from your book are available to answer again online and you can filter them by paper or by type, e.g. Practical Skills. There’s also a QR code on each page of your book that will take you directly to the questions for that page. You’ll mark some of the questions yourself by looking at the answers, and the rest are marked automatically in CGP RevisionHub — wow!<strong> &nbsp;</strong><br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I clear my progress so far in CGP RevisionHub and start again?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can reset your answers in the Online Workbook any time you like! There are no takie-backsies in the quizzes though, so you can’t wipe your results and start again from scratch. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Keep going, we believe in you! &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I share my quiz scores and test results with other people?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that? &nbsp; &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What happens when I’ve answered all the questions?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. You’ve got this.&nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Will I always have access to CGP RevisionHub?</strong><strong> &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise. <br>\n" +
        '&nbsp;</p>',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam Skills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/online-edition.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Knowledge Organisers',
        ImagePath: '/assets/images/landing/knowledge-organisers.png',
        DestinationPage: 'knowledge-organisers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.NotSet,
      },
    ],
    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '',
        Proxy: ProxyTypeEnum.NotSet,
      },
    ],
    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'There’s plenty more revision where this came from! Take a look at some of our other revision books.',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
